export const products = [
  {
    id: 'p1',
    name: 'The Structural Trench',
    price: 495,
    category: 'Outerwear',
    image: 'https://images.unsplash.com/photo-1550614000-4b95d4ed798a?q=80&w=1974&auto=format&fit=crop',
    description: 'A reimagined classic. Oversized fit, dropped shoulders, and sharp lapels cut from heavy cotton gabardine.',
    details: ['100% Cotton Gabardine', 'Water-resistant', 'Removable belt', 'Dry clean only'],
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    inventory: 12
  },
  {
    id: 'p2',
    name: 'Poplin Core Shirt',
    price: 185,
    category: 'Tops',
    image: 'https://images.unsplash.com/photo-1604695573706-53170668f6a6?q=80&w=1974&auto=format&fit=crop',
    description: 'Crisp, structured, and inherently versatile. Features an exaggerated collar and hidden button placket.',
    details: ['100% Organic Cotton', 'Oversized fit', 'French seams', 'Machine wash cold'],
    sizes: ['S', 'M', 'L'],
    inventory: 45
  },
  {
    id: 'p3',
    name: 'Pleated Wool Trouser',
    price: 290,
    category: 'Bottoms',
    image: 'https://images.unsplash.com/photo-1584865288642-42078afe6942?q=80&w=1974&auto=format&fit=crop',
    description: 'High-waisted, wide-leg silhouette tailored from lightweight virgin wool.',
    details: ['100% Virgin Wool', 'Double front pleats', 'Unfinished hem', 'Dry clean only'],
    sizes: ['28', '30', '32', '34', '36'],
    inventory: 8
  },
  {
    id: 'p4',
    name: 'Silk Slip Bias',
    price: 320,
    category: 'Dresses',
    image: 'https://images.unsplash.com/photo-1515347619152-c672b1a9e3b4?q=80&w=1974&auto=format&fit=crop',
    description: 'Cut on the bias to drape flawlessly. Minimalist elegance in heavyweight sandwashed silk.',
    details: ['100% Mulberry Silk', 'Ankle length', 'Adjustable straps', 'Hand wash cold'],
    sizes: ['XS', 'S', 'M', 'L'],
    inventory: 0 // Sold out test
  },
  {
    id: 'p5',
    name: 'Architectural Knit',
    price: 245,
    category: 'Tops',
    image: 'https://images.unsplash.com/photo-1556905055-8f358a7a4bb4?q=80&w=1974&auto=format&fit=crop',
    description: 'Heavyweight ribbed knit with a sculptural neckline and elongated sleeves.',
    details: ['80% Merino Wool, 20% Cashmere', 'Relaxed fit', 'Ethically sourced'],
    sizes: ['S/M', 'L/XL'],
    inventory: 22
  },
  {
    id: 'p6',
    name: 'Column Midi Skirt',
    price: 210,
    category: 'Bottoms',
    image: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=1964&auto=format&fit=crop',
    description: 'A sleek, straight-cut midi skirt with a subtle back vent for movement.',
    details: ['Technical Crepe', 'Hidden side zip', 'Unlined'],
    sizes: ['0', '2', '4', '6', '8', '10'],
    inventory: 15
  }
];

export const lookbook = [
  {
    id: 'l1',
    title: 'Volume & Void',
    image: 'https://images.unsplash.com/photo-1485230895905-31d74394f10a?q=80&w=1974&auto=format&fit=crop',
    items: ['The Structural Trench', 'Poplin Core Shirt']
  },
  {
    id: 'l2',
    title: 'Stark Contrast',
    image: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?q=80&w=2070&auto=format&fit=crop',
    items: ['Pleated Wool Trouser', 'Silk Slip Bias']
  }
];

export const faqs = [
  {
    question: 'Fit Guide & Sizing',
    answer: 'ArcLoom pieces are intentionally designed with an oversized, architectural fit. Detailed garment measurements are available on each product page.'
  },
  {
    question: 'Shipping & Delivery',
    answer: 'Complimentary express shipping on all orders over $300. Standard orders are processed within 1-2 business days.'
  },
  {
    question: 'Returns & Exchanges',
    answer: 'We accept returns of unworn, unaltered merchandise with original tags attached within 14 days of delivery.'
  }
];

export const reviews = [
  { id: 1, author: 'E. R.', rating: 5, text: 'The trench coat entirely changed my silhouette. Uncompromising quality.' },
  { id: 2, author: 'M. K.', rating: 5, text: 'Finally, a brand that understands true minimalism.' },
  { id: 3, author: 'S. T.', rating: 4, text: 'The wool trousers drape beautifully. Had to get them hemmed.' }
];